export const LANDING_PAGE = "/";
export const PAYMENT_LINK = "/payment-link/";
export const PAYMENT_LINK_PUBLIC_PAGE = "/payment-link/:operationId";
export const PUBLIC_RECEIPT_PAGE = "/digital-receipt/:receiptId";
export const PAYMENT_LINK_OVERVIEW_PAGE = "/payment-link/overview";
export const PAYMENT_LINK_METHOD_PAGE = "/payment-link/method";
export const PAYMENT_LINK_BANK_TRF_DETAILS = "/payment-link/bank-transfer";
export const PAYMENT_LINK_BANK_TRF_PENDING =
  "/payment-link/bank-transfer-pending";
export const PAYMENT_LINK_USSD_CODE_DETAILS = "/payment-link/ussd-code";
export const PAYMENT_LINK_USSD_CODE_PENDING = "/payment-link/ussd-code-pending";
export const PAYMENT_LINK_QR_CODE_DETAILS = "/payment-link/qr-code";
export const PAYMENT_LINK_QR_CODE_PENDING = "/payment-link/qr-code-pending";
export const PAYMENT_LINK_CARD_DETAILS = "/payment-link/card";
export const PAYMENT_LINK_CARD_PENDING = "/payment-link/card-pending";
export const PAYMENT_LINK_SUCCESS = "/payment-link/success";

// #region Open payment link flow
export const OPEN_PAYMENT_LINK = "/pay/";
export const OPEN_PAYMENT_LINK_PAGE = "/pay/:linkId";
export const OPEN_PAYMENT_LINK_METHOD = "/pay/:linkId/method";
export const OPEN_PAYMENT_LINK_BANK_TRANSFER = "/pay/:linkId/bank-transfer";
export const OPEN_PAYMENT_LINK_QR_CODE = "/pay/:linkId/qr-code";
export const OPEN_PAYMENT_LINK_USSD = "/pay/:linkId/ussd";
export const OPEN_PAYMENT_LINK_SUCCESS = "/pay/:linkId/success";
export const OPEN_PAYMENT_LINK_CARD_PENDING = "/pay/card-pending";
// #endregion Open payment link flow

// #region Sign-In flow
export const SIGN_IN = "/sign-in";
export const SIGN_IN_TWO_FACTOR = "/sign-in/two-factor";
export const TWO_FACTOR_LAYOUT = "/sign-in/two-factor";
export const FORGOT_PIN = "/forgot-pin";
export const NEW_USER_PIN = "/new-user";
export const MOBILE_VERIFICATION = "/mobile-verification";
export const CREATE_NEW_PIN = "/create-new-pin";
export const ACCEPT_INVITATION = "/accept-invitation";
export const SELECT_PROFILE = "/select-profile";
// #endregion Sign-In flow

// #region Sign-Up flow
export const SIGN_UP = "/sign-up";
export const SIGN_UP_USER = "/sign-up/user";
export const SIGN_UP_PHOTO_VERIFICATION = "/sign-up/photo-verification";
export const SIGN_UP_MOBILE_VERIFICATION = "/sign-up/mobile-verification";
export const PROFILE_CREATION = "/sign-up/profile-creation";
export const BUSINESS_REGISTRATION = "/sign-up/business-registration";
export const BUSINESS_REGISTRATION_TYPE = "/sign-up/business-registration-type";
export const BUSINESS_VERIFICATION = "/sign-up/business-verification";
export const BUSINESS_VERIFICATION_PERSONAL_DETAILS =
  "/sign-up/business-verification/personal-details";
export const BUSINESS_VERIFICATION_PHOTO_VERIFICATION =
  "/sign-up/business-verification/photo-verification";
export const BUSINESS_VERIFICATION_BUSINESS_INFO =
  "/sign-up/business-verification/business-information";
export const BUSINESS_VERIFICATION_DOCUMENTS =
  "/sign-up/business-verification/documents";
export const BUSINESS_VERIFICATION_PEOPLE =
  "/sign-up/business-verification/people";
export const BUSINESS_VERIFICATION_PEOPLE_VERIFY =
  "/sign-up/business-verification/people/verify";
export const BUSINESS_VERIFICATION_PEOPLE_EMAIL_LANDING =
  "/sign-up/business-verification/people/email-landing";
// Matches StakeholderInvitationApiService.validateToken/submitInviteeKyc/
// verifyInviteeBvn — that whole flow is token-only (no userExternalId, no
// admin session). stakeholderId in the path isn't used for anything client
// side; only the trailing :token segment is.
export const BUSINESS_VERIFICATION_PEOPLE_INVITE_LINK =
  "/onboarding/invitations/:stakeholderId/:token";
export const BUSINESS_VERIFICATION_PEOPLE_EMAIL_FORM =
  "/sign-up/business-verification/people/email-form";
export const BUSINESS_VERIFICATION_ACCOUNT =
  "/sign-up/business-verification/account";
export const BUSINESS_VERIFICATION_REVIEW =
  "/sign-up/business-verification/review";
export const BUSINESS_VERIFICATION_SUBMITTING =
  "/sign-up/business-verification/submitting";
export const BUSINESS_VERIFICATION_UNDER_REVIEW =
  "/sign-up/business-verification/under-review";

// #endregion Sign-Up flow

export const PIN_CREATED = "/pin-created";
export const ACCOUNT_CREATED = "/account-created";
export const DASHBOARD = "/dashboard";
export const ANALYTICS = "/analytics";
export const ANALYTICS_UNDO_SALE = "/analytics/undo-sale";
export const SETTINGS = "/settings";
export const STATEMENTS = "/statements";

// #region Upgrade Account Tier flow
export const UPGRADE_ACCOUNT = "/upgrade-account";
export const UPGRADE = "/upgrade";
export const END_UPGRADE_PAGE = "/upgrade/end-page";
// #endregion Upgrade Account Tier flow

// #region Loans flow
export const LOANS = "/loans";
export const LOANS_SUCCESS = "/loans/success";
// #endregion Loans flow

// #region Payment Flow
// Removed legacy payment route
export const PAYMENT_SUCCESS = "/payment/success";
export const PAYMENT_BANK_TRANSFER = "/payment/bank-transfer";
export const PAYMENT_QR_CODE = "/payment/qr-code";
export const PAYMENT_USSD_CODE = "/payment/ussd-code";
export const PAYMENT_PAYMENT_LINK = "/payment/payment-link";
export const PAYMENT_LINK_CONFIRMATION = "/payment-link-confirmation";

// Additional payment routes
export const PAYMENT = "/payment";
export const PAYMENT_OVERVIEW = "/payment/overview";
export const COLLECT_PAYMENT = "/collect-payment";
export const MAKE_PAYMENT = "/make-payment";
export const PAYMENT_BANK_TRANSFER_PENDING = "/payment/bank-transfer/pending";
export const PAYMENT_QR_CODE_PENDING = "/payment/qr-code/pending";
export const PAYMENT_USSD_CODE_PENDING = "/payment/ussd-code/pending";
export const PAYMENT_PENDING_SALE = "/payment/pending-sale";
export const PAYMENT_CONFIRM_TRANSFER = "/payment/confirm-transfer";
// #endregion Payment Flow

// #region Transactions Flow
export const TRANSACTIONS = "/transactions";
export const TRANSACTIONS_TRANSACTION_DETAILS = "/transactions/transaction";
export const OPERATION_CONFIRMATION = "/operation-confirmation";
export const TRANSACTIONS_REFUND = "/transactions/refund";
export const TRANSACTIONS_REFUND_OVERVIEW = "/transactions/refund/overview";
export const TRANSACTIONS_REFUND_PIN = "/transactions/refund/overview/pin";
export const TRANSACTIONS_REFUND_AUTHENTICATION =
  "/transactions/refund/overview/authentication";
export const TRANSACTIONS_REFUND_SUCCESS =
  "/transactions/refund/overview/success";
// #endregion Transactions Flow

// #region Send Money Flow
export const SEND_MONEY = "/send-money";
export const SEND_MONEY_OVERVIEW = "/send-money/overview";
export const SEND_MONEY_PIN = "/send-money/overview/pin";
export const SEND_MONEY_AUTHENTICATION = "/send-money/overview/authentication";
export const SEND_MONEY_SUCCESS = "/send-money/success";
// #endregion Send Money Flow

// #region Beneficiaries Flow
export const BENEFICIARIES = "/beneficiaries";
export const VIRTUAL_ACCOUNTS = "/virtual-accounts";
export const VIRTUAL_ACCOUNT_CREATE = "/virtual-accounts/create";
export const VIRTUAL_ACCOUNT_TRANSACTION_DETAILS =
  "/virtual-accounts/transaction";
export const VIRTUAL_ACCOUNT_DETAILS = "/virtual-accounts/:accountNumber";
// #endregion Beneficiaries Flow

// #region Outlet Management Flow
export const OUTLET_MANAGEMENT = "/outlet-management";
export const OUTLET_CREATE = "/outlet-management/create";
export const OUTLET_DETAILS = "/outlet-management/details";
export const POS_TRANSACTION_HISTORY =
  "/outlet-management/details/pos/transactions";
export const OUTLET_WITHDRAWAL_HISTORY =
  "/outlet-management/details/withdrawals";
// #endregion Outlet Management Flow

// #region POS Management Flow
export const POS_MANAGEMENT = "/pos-management";
export const POS_VIEW_OFFER = "/pos-management/view-offer";
export const POS_DETAILS = "/pos-management/details/pos";
export const POS_REQUEST_REVIEW = "/pos-management/review";
export const POS_REQUEST_SUBMIT = "/pos-management/submit";
export const POS_TRANSACTION_PIN = "/pos-management/pin";
export const POS_AUTHENTICATION = "/pos-management/authentication";
export const POS_PAYMENT_METHOD = "/pos-management/payment-method";
// #endregion POS Management Flow

//  #region Inventory Flow
export const INVENTORY = "/inventory";
export const ADD_NEW_PRODUCT = "/inventory/add-new-product";
// #endregion Inventory Flow

// #region Settings Flow
export const PROFILE_MANAGEMENT = `${SETTINGS}/profile-management`;
export const TRANSACTION_PIN = `${SETTINGS}/transaction-pin`;
export const CHANGE_PASSWORD = `${SETTINGS}/change-password`;
export const TWO_FACTOR_AUTH = `${SETTINGS}/two-factor-authentication`;
export const TEAM_MANAGEMENT = `${SETTINGS}/team-management`;
export const TEAM_MEMBER_DETAILS = `${TEAM_MANAGEMENT}/:id`;
export const SYSTEM_PREFERENCE = `${SETTINGS}/system-preference`;
export const NOTIFICATION_PREFERENCES = `${SETTINGS}/notifications`;
// #endregion Settings Flow

// #region Error Handler
export const ERROR_HANDLER = "/not-found";
